module.exports = __webpack_public_path__ + "img/vermelho_horizontal.4a79de32.png";